.navigation {
  position: absolute;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 1.5rem;
}

.menu {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.main {
  min-height: 100vh;
  padding-top: 6rem;
  padding-bottom: 6rem;
}

.gray {
  background: var(--gray-200);
}
